import { makeStyles } from '@material-ui/core/styles';

const FileListStyles = makeStyles(({ spacing }) => ({
  FileList: {
    '& .FileItem': {
      margin: spacing(0, 0, 2),
    },
    '& .FileItem:last-child': {
      margin: 0,
    },
  },
}));

export default FileListStyles;
